import React, { useState, useEffect, useMemo } from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import { useHandleFile } from "../../../core/hooks/useHandleFile";
import { Checkbox, Image, Progress } from "antd";
import {
  domParser,
  extractCourseGeneralContents,
  extractTextAndUrls,
} from "../../../core/common/ults/domParser";
import { useDispatch } from "react-redux";
import { setCourseLesson } from "../../../core/redux/courseLessonSlice";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileLines,
  faComments,
  faMessage,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
import {
  AssignIcon,
  LiveClassIcon,
  QuizIcon,
} from "../../../core/common/icons/icons";
import { ForumModal, PageModal, QuizModal, UrlModal } from "./modal";
import LiveClassModal from "../../../core/components/LiveClassModal";
import { useBigBlueButtonActivities } from "../../../core/hooks/useBigBlueButton";
import { useTranslation } from "react-i18next";
import { useHandleAssign } from "../../../core/hooks/useHandleAssign";
import { useHandleQuiz } from "../../../core/hooks/useHandleQuiz";
import { useTrackList } from "../../../core/hooks/useTrackVideo";
import { useHandleForum } from "../../../core/hooks/useHandleForum";
import { useAuth } from "../../../core/hooks/useAuth";
import { useHandleCompleModule } from "../../../core/hooks/useHandleCompleModule";
const CourseDetails = () => {
  const location = useLocation();
  const { course, percent } = location.state || {};
  const { id } = useParams();
  const dispatch = useDispatch();
  const [selectedModule, setSelectedModule] = useState<any>(null);
  const [showModuleModal, setShowModuleModal] = useState(false);
  const [showLiveClassModal, setShowLiveClassModal] = useState(false);
  const [selectedBigBlueButtonActivity, setSelectedBigBlueButtonActivity] =
    useState<any>(null);
  const [selectedQuizId, setSelectedQuizId] = useState<number | null>(null);
  const { moodleUser } = useAuth();
  const { data: trackList } = useTrackList(id, moodleUser);

  const { t } = useTranslation();

  const { courseContents, courseDetails, pageContent } = useHandleCourses(id);
  const courseDetailData = courseDetails?.courses[0];

  const quizInstances = courseContents
    ?.flatMap((section: any) => section.modules || []) // gom tất cả modules từ các section
    ?.filter((module: any) => module.modname === "quiz") // chỉ lấy module loại "quiz"
    ?.map((quizModule: any) => quizModule.instance); // lấy ra instance  // Get BigBlueButton activities for this course

  const { data: bigBlueButtonActivities } = useBigBlueButtonActivities(
    courseDetailData?.id ? parseInt(courseDetailData.id) : 0
  );

  const { moodleAssigns, viewAssignMutation } = useHandleAssign(id);
  const [selectedAssignId, setSelectedAssignId] = useState<number | null>(null);
  const [pendingAssignModule, setPendingAssignModule] = useState<any>(null);
  const assignDetailHandle = useHandleAssign(selectedAssignId);

  const navigate = useNavigate();

  const handleSelectLesson = (
    sectionIndex: number,
    lessonIndex: number,
    itemIndex: number,
    lesson: any
  ) => {
    dispatch(
      setCourseLesson({
        courseData: {
          courseDetail: courseDetailData,
          courseContentData: courseContents,
          courseOverview: course,
        },
        selectedLesson: {
          sectionIndex: Number(sectionIndex),
          lessonIndex: Number(lessonIndex),
          itemIndex: Number(itemIndex),
          lesson,
        },
      })
    );
  };

  const countModulesByType = (modname: string): number => {
    return (
      courseContents
        ?.flatMap((section: any) => section.modules || [])
        ?.filter((module: any) => module.modname === modname)?.length || 0
    );
  };

  const countCompletedModulesByType = (modname: string): number => {
    return (
      courseContents
        ?.flatMap((section: any) => section.modules || [])
        ?.filter(
          (module: any) =>
            module.modname === modname &&
            [1, 2].includes(module.completiondata?.state)
        )?.length || 0
    );
  };

  const totalQuizModules = countModulesByType("quiz");
  const totalAssignModules = countModulesByType("assign");

  const completedQuiz = countCompletedModulesByType("quiz");
  const completedAssign = countCompletedModulesByType("assign");
  const quizProgressPercent = totalQuizModules
    ? Math.round((completedQuiz / totalQuizModules) * 100)
    : 0;

  const assignProgressPercent = totalAssignModules
    ? Math.round((completedAssign / totalAssignModules) * 100)
    : 0;

  const exerciseProgressPercent = Math.round(
    (assignProgressPercent + quizProgressPercent) / 2
  );

  const allModules =
    courseContents?.flatMap((section: any) => section.modules || []) || [];
  const countOtherModules = (): number => {
    return allModules.filter(
      (mod: any) =>
        mod.modname === "forum" && mod.completion > 0
    ).length;
  };

  const countCompletedOtherModules = (): number => {
    return allModules.filter(
      (mod: any) =>
        mod.modname === "forum" &&
        [1, 2].includes(mod.completiondata?.state)
    ).length;
  };

  const otherProgressPercent = countOtherModules()
    ? Math.round((countCompletedOtherModules() / countOtherModules()) * 100)
    : 0;

  const { moodleFileSrc, isMoodleFileSrcLoading } = useHandleFile(
    courseDetailData?.overviewfiles[0]?.fileurl
  );

  const { viewForum } = useHandleForum();
  const { viewUrl } = useHandleCompleModule();

  const getModuleIcon = (modname: string) => {
    switch (modname) {
      case "page":
        return <FontAwesomeIcon icon={faFileLines} className="text-info" />;
      case "forum":
        return (
          <FontAwesomeIcon icon={faComments} className="text-chromeyellow" />
        );
      case "chat":
        return <FontAwesomeIcon icon={faMessage} className="text-success" />;
      case "url":
        return <FontAwesomeIcon icon={faBook} className="text-info" />;
      case "bigbluebuttonbn":
        return <LiveClassIcon className="text-danger fs-20" />;
      case "quiz":
        return <QuizIcon className="text-warning fs-20" />;
      case "assign":
        return <AssignIcon className="text-warning fs-20" />;
      default:
        return null;
    }
  };
  const getDueDateFromAssign = (instanceId: number) => {
    return moodleAssigns?.courses
      ?.flatMap((course: any) => course.assignments)
      ?.find((assignment: any) => assignment.id === instanceId)?.duedate;
  };
  const getAllowSubmissionsFromDateFromAssign = (instanceId: number) => {
    return moodleAssigns?.courses
      ?.flatMap((course: any) => course.assignments)
      ?.find((assignment: any) => assignment.id === instanceId)?.allowsubmissionsfromdate;
  };

  const getIntroFromAssign = (instanceId: number) => {
    return moodleAssigns?.courses
      ?.flatMap((course: any) => course.assignments)
      ?.find((assignment: any) => assignment.id === instanceId)?.intro;
  };

  const getFilesFromAssign = (instanceId: number) => {
    return moodleAssigns?.courses
      ?.flatMap((course: any) => course.assignments)
      ?.find((assignment: any) => assignment.id === instanceId)?.introattachments || [];
  };

  const handleOpenModal = async (module: any) => {
    if (module.modname === "bigbluebuttonbn") {
      // Find the corresponding BigBlueButton activity
      const bbbActivity = bigBlueButtonActivities?.data?.find(
        (activity: any) => activity.coursemodule === module.id
      );
      if (bbbActivity) {
        setSelectedBigBlueButtonActivity(bbbActivity);
        setShowLiveClassModal(true);
      } else {
        console.warn("BigBlueButton activity not found for module:", module);
      }
    } else if (module.modname === "assign") {
      setSelectedAssignId(module.instance);
      setPendingAssignModule(module);
      await viewAssignMutation.mutateAsync(module.instance);
      // Việc còn lại sẽ xử lý trong useEffect phía dưới
      return;
    } else if (module.modname === "forum") {
      // Gọi view forum để track khi user mở forum
      try {
        viewForum(module.instance);
      } catch {}
      setSelectedModule(module);
      setShowModuleModal(true);
    } else if (module.modname === "url") {
      viewUrl(module.instance);
      setSelectedModule(module);
      setShowModuleModal(true);
    } else {
      setSelectedModule(module);
      setShowModuleModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModuleModal(false);
  };

  const handleCloseLiveClassModal = () => {
    setShowLiveClassModal(false);
    setSelectedBigBlueButtonActivity(null);
  };

  useEffect(() => {
    // Khi selectedAssignId và pendingAssignModule thay đổi, kiểm tra và tạo submission nếu cần
    const checkAndCreateSubmission = async () => {
      if (selectedAssignId && pendingAssignModule) {
        // Nếu chưa có submission thì tạo submission
        if (!assignDetailHandle.statusSubmissions?.lastattempt?.submission) {
          await assignDetailHandle.creatSubmissionMutation.mutateAsync(
            selectedAssignId
          );
        }
        // Chờ 1 chút để Moodle tạo submission
        setTimeout(() => {
          const duedate = getDueDateFromAssign(selectedAssignId);
          const allowSubmissionsFromDate = getAllowSubmissionsFromDateFromAssign(selectedAssignId);
          const intro = getIntroFromAssign(selectedAssignId);
          const filesArray = getFilesFromAssign(selectedAssignId);
          navigate(`${all_routes.studentAssignQuestion}/${selectedAssignId}`, {
            state: {
              courseName:courseDetailData?.fullname,
              assignDuedate: duedate,
              allowSubmissionsFromDate: allowSubmissionsFromDate,
              introAssign: intro,
              filesArray: filesArray,
              modName: pendingAssignModule.name,
            },
          });
          setSelectedAssignId(null);
          setPendingAssignModule(null);
        }, 800);
      }
    };
    checkAndCreateSubmission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedAssignId,
    pendingAssignModule,
    assignDetailHandle.statusSubmissions,
  ]);
  const normalizeUrl = (url: string) => {
    try {
      const u = new URL(decodeURIComponent(url));
      return u.origin + u.pathname;
    } catch {
      return url;
    }
  };

  const videoStatusMap = useMemo(() => {
    if (!trackList?.length) return {};
    return trackList.reduce((map: any, item: any) => {
      const cleanUrl = normalizeUrl(item.videoid);
      const ts = Math.floor(Number(item.playtime) || 0);
      const dur = Math.floor(Number(item.duration) || 0);
      let status = "notStarted";
      if (ts > 0 && ts < dur) status = "inProgress";
      else if (ts >= dur && dur > 0) status = "completed";
      const percent = dur > 0 ? Math.floor((ts / dur) * 100) : 0;
      map[cleanUrl] = { status, percent };
      return map;
    }, {});
  }, [trackList]);

  const getVideoInfo = (url: string) => {
    const key = normalizeUrl(url);
    const entry = (videoStatusMap as any)[key];
    if (!entry) return { status: "Chưa xem", percent: 0 };
    const label =
      entry.status === "completed"
        ? "Đã xem"
        : entry.status === "inProgress"
        ? "Đang xem"
        : "Chưa xem";
    return { status: label, percent: entry.percent };
  };

  const weekData = (courseContents || [])
    .filter((section: any) => section.section > 0)
    .map((section: any) => {
      const videos =
        section.modules?.flatMap((mod: any) => {
          const list: any[] = [];
          const pushVideo = (name: string, url: string) => {
            const info = getVideoInfo(url);
            list.push({ name, ...info });
          };
          if (mod.modname === "unilabel") {
            const result = extractTextAndUrls(mod.description);
            result?.items?.forEach((res: any) => {
              if (res.type === "video" || res.url?.includes(".mp4"))
                pushVideo(res.text, res.url);
            });
          } else if (mod.modname === "resource") {
            const fileUrl = mod.contents?.[0]?.fileurl;
            if (fileUrl?.includes(".mp4")) pushVideo(mod.name, fileUrl);
          } else if (mod.modname === "url") {
            const externalUrl = mod.contents?.[0]?.fileurl || mod.externalurl;
            if (
              externalUrl &&
              (externalUrl.includes(".mp4") ||
                externalUrl.includes("youtube") ||
                externalUrl.includes("vimeo"))
            ) {
              pushVideo(mod.name, externalUrl);
            }
          }
          return list;
        }) || [];
      return { videos };
    });

  const calculateWeekProgress = (videos: any[]) => {
    if (!videos || videos.length === 0) return 0;

    const total = videos.length;
    const completed = videos.filter((v: any) => v.status === "Đã xem").length;
    return Math.round((completed / total) * 100);
  };

  const totalWeeks = weekData?.filter(
    (week: any) => week.videos.length > 0
  ).length;

  const completedWeeks = weekData.filter(
    (week: any) => calculateWeekProgress(week.videos) === 100
  ).length;

  const theoryProgressPercent =
    totalWeeks > 0 ? Math.round((completedWeeks / totalWeeks) * 100) : 0;

  const courseProgressPercent = Math.round(
    (theoryProgressPercent + otherProgressPercent + exerciseProgressPercent) / 3
  );
  return (
    <>
      <>
        {/* Course detail */}
        <section className="course-details-two">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <Breadcrumb title={t("courseDetails.title")} />
                <div className="card bg-light">
                  <div className="card-body d-lg-flex align-items-center">
                    <div className="position-relative">
                      {isMoodleFileSrcLoading ? (
                        <SkeletonTheme
                          baseColor="#cccccc"
                          highlightColor="#f5f5f5"
                        >
                          <Skeleton height={300} className="mb-3" />
                        </SkeletonTheme>
                      ) : (
                        <Image
                          className="img-fluid rounded-2"
                          src={moodleFileSrc}
                          alt="img"
                        />
                      )}
                    </div>
                    <div className="w-100 ps-lg-4">
                      <h3 className="mb-2">{courseDetailData?.fullname}</h3>
                      <p
                        className="fs-14 mb-3"
                        dangerouslySetInnerHTML={{
                          __html: domParser(
                            extractCourseGeneralContents(
                              courseContents?.[0]?.modules?.[0]?.description
                            ) || t("courseDetails.noDescription")
                          ),
                        }}
                      />
                      <div className="d-flex align-items-center gap-2 gap-sm-3 gap-xl-4 flex-wrap my-3 my-sm-0">
                        <p className="fw-medium d-flex align-items-center mb-0">
                          <ImageWithBasePath
                            className="me-2"
                            src="./assets/img/icons/book.svg"
                            alt="img"
                          />
                          {courseContents?.length - 1}{" "}
                          {t("courseDetails.lesson")}
                        </p>
                        <p className="fw-medium d-flex align-items-center mb-0">
                          <ImageWithBasePath
                            className="me-2"
                            src="./assets/img/icons/people.svg"
                            alt="img"
                          />
                          {course?.enrolledusercount}{" "}
                          {t("courseDetails.studentsEnrolled")}
                        </p>
                        <span className="badge badge-sm rounded-pill bg-warning fs-12">
                          {courseDetailData?.categoryname}
                        </span>
                        <Progress
                          percent={courseProgressPercent}
                          size="default"
                          strokeColor={
                            percent >= 90
                              ? "#52c41a"
                              : percent >= 50
                              ? "#1677ff"
                              : "#ff4d4f"
                          }
                          className="w-50"
                        />
                      </div>
                      <div className="d-sm-flex align-items-center justify-content-sm-between mt-3">
                        <div className="d-flex align-items-center"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="row d-flex ms-auto me-auto gap-3">
                <div className="col-lg-4 card mb-4 flex-grow-2">
                  {/* general block */}
                  <div className="card-body">
                    <h5 className="mb-3">{t("courseDetails.overview")}</h5>
                    {courseContents?.[0]?.modules
                      ?.slice(1)
                      .map((item: any, idx: any) => (
                         <div
                           key={idx}
                           className="d-flex align-items-center justify-content-between gap-3 mb-3"
                         >
                           <div className="d-flex align-items-center gap-3">
                             {getModuleIcon(item?.modname)}
                             <Link
                               to=""
                               className="d-inline-flex fs-14 me-1 module-link"
                               onClick={(e) => {
                                 e.preventDefault();
                                 handleOpenModal(item);
                               }}
                             >
                               <span className="fs-16">{item?.name}</span>
                             </Link>
                           </div>
                           
                           {(item.modname === "quiz" ||
                             item.modname === "assign" ||
                             item.modname === "forum") && (
                             <Checkbox
                               checked={[1, 2].includes(
                                 item.completiondata?.state
                               )}
                               disabled
                             />
                           )}
                         </div>
                      ))}
                  </div>
                </div>
                {/* progress block */}
                <div className="card mb-4 col-lg-4 flex-grow-1">
                  <div className="card-body">
                    <h5 className="subs-title mb-4">
                      {t("courseDetails.progress")}
                    </h5>
                    <div className="d-flex gap-5 justify-items-center">
                      {[
                        {
                          title: t("progress.theory"),
                          percent: theoryProgressPercent,
                        },
                        {
                          title: t("progress.exercises"),
                          percent: exerciseProgressPercent,
                        },
                        {
                          title: t("progress.activity"),
                          percent: otherProgressPercent,
                        },
                      ].map((item, index) => (
                        <div
                          key={index}
                          className="d-flex flex-column align-items-center"
                        >
                          <p className="mb-2 text-center">{item.title}</p>
                          <Progress
                            type="circle"
                            percent={item.percent}
                            strokeColor={
                              item.percent === 100
                                ? "#52c41a" // 100% thì toàn bộ màu xanh
                                : {
                                    "0%": "#ff4d4f",
                                    "40%": "#faad14",
                                    "90%": "#52c41a",
                                  }
                            }
                            size={90}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="course-page-content pt-2">
                  {/* Course Content Section */}
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="d-flex justify-content-between flex-wrap">
                        <h5 className="subs-title mb-2 mb-sm-3">
                          {t("courseDetails.courseContent")}
                        </h5>
                      </div>
                      <div
                        className="accordion accordion-customicon1 accordions-items-seperate p-0"
                        id="accordioncustomicon1Example"
                      >
                        {courseContents
                          ?.slice(1)
                          ?.map((item: any, sectionIndex: any) => (
                            <div
                              key={sectionIndex}
                              className="accordion-item"
                              data-aos="fade-up"
                            >
                              <h2
                                className="accordion-header"
                                id={`headingcustomicon1${sectionIndex}`}
                              >
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#collapsecustomicon1${sectionIndex}`}
                                  aria-expanded="false"
                                  aria-controls={`collapsecustomicon1${sectionIndex}`}
                                >
                                  {item?.name}
                                  <i className="fa-solid fa-chevron-down" />
                                </button>
                              </h2>
                              <div
                                id={`collapsecustomicon1${sectionIndex}`}
                                className="accordion-collapse collapse"
                                aria-labelledby={`headingcustomicon1${sectionIndex}`}
                                data-bs-parent="#accordioncustomicon1Example"
                              >
                                <div className="accordion-body p-0">
                                  <ul>
                                    {item?.modules?.map(
                                      (moduleItem: any, lessonIndex: any) => {
                                        // unilabel block
                                        if (moduleItem?.modname === "unilabel") {
                                          const { title, items } =
                                            extractTextAndUrls(
                                              moduleItem?.description
                                            );
                                          return (
                                            <div
                                              key={moduleItem.id}
                                              className="learning-materials-container p-3 bg-light rounded-3 border mt-3"
                                            >
                                              <h6 className="mb-3 fw-semibold">
                                                {title ||
                                                  t(
                                                    "courseDetails.learningMaterials"
                                                  )}
                                              </h6>
                                              {items?.map(
                                                (
                                                  material: any,
                                                  itemIndex: any
                                                ) => (
                                                  <li
                                                    key={`${moduleItem.id}-${itemIndex}`}
                                                    className="d-flex justify-content-between align-items-center list-unstyled mb-2"
                                                  >
                                                    <p className="mb-0">
                                                      <ImageWithBasePath
                                                        className="me-2"
                                                        src={
                                                          material.type ===
                                                          "pdf"
                                                            ? "./assets/img/icons/book.svg"
                                                            : "./assets/img/icons/play.svg"
                                                        }
                                                        alt="icon"
                                                      />
                                                      {material?.text}
                                                    </p>
                                                    <div className="d-flex align-items-center gap-xl-5 gap-3">
                                                      <Link
                                                        to={`${all_routes.courseWatch}/${id}`}
                                                        className="btn btn-info"
                                                        onClick={() =>
                                                          handleSelectLesson(
                                                            sectionIndex,
                                                            lessonIndex,
                                                            itemIndex,
                                                            material
                                                          )
                                                        }
                                                      >
                                                        {t(
                                                          "courseDetails.watch"
                                                        )}
                                                      </Link>
                                                    </div>
                                                  </li>
                                                )
                                              )}
                                            </div>
                                          );
                                        } else {
                                          // other module block
                                          return (
                                            <div
                                              key={moduleItem.id}
                                              className="d-flex align-items-center justify-content-between gap-3 mt-3"
                                            >
                                              <div className="d-flex align-items-center gap-3">
                                                {getModuleIcon(
                                                  moduleItem?.modname
                                                )}
                                                <Link
                                                  to=""
                                                  className="d-inline-flex fs-14 me-1 module-link"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    handleOpenModal(moduleItem);
                                                  }}
                                                >
                                                  <span className="fs-16">
                                                    {moduleItem?.name}
                                                  </span>
                                                </Link>
                                              </div>

                                              {(moduleItem.modname ===
                                                "quiz" ||
                                                moduleItem.modname ===
                                                  "assign" ||
                                                moduleItem.modname ===
                                                  "forum") && (
                                                <Checkbox
                                                  checked={[1, 2].includes(
                                                    moduleItem.completiondata
                                                      ?.state
                                                  )}
                                                  disabled
                                                />
                                              )}
                                            </div>
                                          );
                                        }
                                      }
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="course-sidebar-sec mt-0"></div>
              </div>
            </div>
          </div>
        </section>
        {/* /Course detail */}
        {/* {selectedQuizId && (
          <QuizHandler
            quizId={selectedQuizId}
            onFinish={() => setSelectedQuizId(null)}
          />
        )} */}
      </>

      {/* Modal */}
      {showModuleModal && (
        <div className="modal show d-block" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="moduleContentModalLabel">
                  {selectedModule?.name || t("courseDetails.moduleContent")}
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                >
                  <i className="isax isax-close-circle5" />
                </button>
              </div>
              <div className="modal-body mx-3">
                {selectedModule?.modname === "page" && (
                  <PageModal
                    pageContent={pageContent}
                    selectedModule={selectedModule}
                  />
                )}
                {selectedModule?.modname === "url" && (
                  <UrlModal selectedModule={selectedModule} />
                )}
                {selectedModule?.modname === "forum" && (
                  <ForumModal selectedModule={selectedModule} />
                )}
                {selectedModule?.modname === "bigbluebuttonbn" && (
                  <div className="text-center py-4">
                    <p>{t("courseDetails.bigBlueButtonWarning")}</p>
                  </div>
                )}
                {selectedModule?.modname === "quiz" && (
                  <QuizModal selectedModule={selectedModule} />
                )}
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </div>
      )}

      {/* Live Class Modal */}
      {showLiveClassModal && selectedBigBlueButtonActivity && (
        <LiveClassModal
          isOpen={showLiveClassModal}
          onClose={handleCloseLiveClassModal}
          bigBlueButtonActivity={selectedBigBlueButtonActivity}
          courseId={courseDetailData?.id ? parseInt(courseDetailData.id) : 0}
        />
      )}
    </>
  );
};

export default CourseDetails;